import React from 'react';
import FooterSection from './FooterSection';
import FreeOrderSection from './FreeOrderSection';


interface FooterProps {
  withoutOrderFooter?: boolean,
}

const Footer = ({ withoutOrderFooter }: FooterProps) => (
  <>
    <FreeOrderSection withoutOrderFooter={withoutOrderFooter} />
    <FooterSection />
  </>
);


export default Footer;
